import api from './client'

export type ConsentScope = 'REGISTRATION' | 'COOKIE'

export interface RegistrationConsents {
  contract: boolean
  legal_obligations: boolean
  transactional_comms: boolean
  platform_marketing: boolean
  association_marketing: boolean
  profiling: boolean
  third_party_sharing: boolean
}

export interface CookieConsents {
  necessary: boolean
  functional: boolean
  analytics: boolean
  profiling: boolean
  marketing: boolean
}

export interface ConsentBundle {
  id: string
  scope: ConsentScope
  userId?: string
  anonymousId?: string
  policyVersion: string
  consents: RegistrationConsents | CookieConsents
  createdAt: string
  withdrawnAt?: string | null
}

export const consentApi = {
  getRegistration: () =>
    api.get<ConsentBundle | null>('/v1/auth/consent').then((r) => r.data).catch(() => null),

  saveRegistration: (data: {
    userId?: string
    anonymousId?: string
    policyVersion: string
    consents: RegistrationConsents
    collectionContext?: object
  }) =>
    api.post<ConsentBundle>('/v1/auth/consent', data).then((r) => r.data),

  getCookie: (anonymousId: string) =>
    api
      .get<ConsentBundle | null>('/v1/auth/consent/cookie', { params: { anonymousId } })
      .then((r) => r.data),

  saveCookie: (data: {
    anonymousId?: string
    userId?: string
    policyVersion: string
    consents: CookieConsents
  }) =>
    api
      .post<ConsentBundle>('/v1/auth/consent', { ...data, scope: 'COOKIE' })
      .then((r) => r.data),

  withdraw: (data: { consentTypes: string[]; reason?: string }) =>
    api.patch<ConsentBundle>('/v1/auth/consent/withdraw', data).then((r) => r.data),

  withdrawCookie: (data: { anonymousId: string; reason?: string }) =>
    api.post<ConsentBundle>('/v1/auth/consent/cookie/withdraw', data).then((r) => r.data),

  history: () =>
    api.get<{ data: ConsentBundle[] }>('/v1/auth/consent/history').then((r) => r.data),
}
